<template>
	<v-container fluid>
		<v-card color="error" v-if="AppMessage">
			<v-card-text class="text-center">
				{{ AppMessage }}
			</v-card-text>
		</v-card>

		<v-row dense align="center" justify="center">
			<v-col cols="12" sm="10" md="8" lg="5" xl="4">
				<v-img
						:src="$vuetify.theme.dark ? require('@/assets/img/cronaportal-white.png') : require('@/assets/img/cronaportal-dark.png')"
						:lazy-src="$vuetify.theme.dark ? require('@/assets/img/cronaportal-white.png') : require('@/assets/img/cronaportal-dark.png')"
						:max-height="175"
						contain
						class="mb-5 mt-5"
				/>
				<v-card outlined>
					<OpenIDConnect v-if="$route.name === 'OpenIDConnect'" />
					<v-tabs v-else :show-arrows="isMobileApp" v-model="tab" slider-color="accent" :color="$vuetify.theme.dark ? 'accent' : 'primary'" grow>
						<template v-for="(item, index) in tabs">
							<v-tab :key="index">{{item.label}}</v-tab>
						</template>

						<template v-for="(item, index) in tabs">
							<v-tab-item :value="index">
								<v-divider></v-divider>
								<component class="pt-3" v-bind:is="item.component" v-bind="item.params"/>
							</v-tab-item>
						</template>

					</v-tabs>
				</v-card>
			</v-col>
			<v-col cols="12" class="pa-0">

			</v-col>
			<v-col cols="12" class="text-center">
				<MobileStoreButtons/>
			</v-col>
			<v-col cols="12" class="pa-0">

			</v-col>
			<v-col cols="12" class="text-center">
				<AddToHomeScreenBtn/>
			</v-col>
			<v-col cols="12" class="pa-0">

			</v-col>
			<v-col cols="12" class="text-center">
				<LanguagePicker/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import LocalStorage       from '../../lib/LocalStorage.js';
import LanguagePicker     from '../LanguagePicker.vue';
import AddToHomeScreenBtn from '../AddToHomeScreenBtn.vue';
import MobileStoreButtons from '../MobileStoreButtons.vue';
import ElectronicIDLogin  from './Forms/ElectronicIDLogin.vue';
import UsernamePassword   from './Forms/UsernamePassword.vue';
import OpenIDConnect      from './OpenIDConnect.vue';

export default {
	name: 'Login',
	data: () => ({
		AppMessage: '', // 'Just nu upplever vi driftstörningar i Crona Portal. Felsökning pågår och vi arbetar för att åtgärda problemet så snart som möjligt.',
		tab:        parseInt(LocalStorage.get('LoginMethod'), 10) || null,
	}),

	computed: {
		tabs() {
			return [
				{label: this.$t('E-legitimation'), component: 'ElectronicIDLogin', params: {}},
				{label: this.$t('Username'), component: 'UsernamePassword', params: {}},
			];
		},
	},

	components: {
		MobileStoreButtons,
		AddToHomeScreenBtn,
		LanguagePicker,
		UsernamePassword,
		ElectronicIDLogin,
		OpenIDConnect,
	},
}
</script>

<style scoped>
	::v-deep(.v-slide-group__prev, .v-slide-group__next) {
		display: none !important;
	}
</style>
